import { analytics } from '../../services/Analytics/Analytics'
import { useEvent } from 'react-use-event-hook'
import { getFeedCategoriesProperties } from '../../services/Analytics/artCollectionAnalytics'
import { getArtCatalog } from '../../services/artCatalogService'
import { generateProductCountEventProperties } from 'services/Analytics/productsAnalytics'

function useArtCollectionAnalytics() {
  const catalog = getArtCatalog()

  const sendAnalytics = useEvent(
    (
      eventName: string,
      eventProperties: Record<string, unknown> = {},
      serverSideAnalyticsPlatforms: string[] = []
    ) => {
      analytics.track(
        eventName,
        {
          ...getFeedCategoriesProperties(catalog),
          ...generateProductCountEventProperties(),
          ...eventProperties,
        },
        { serverSideAnalyticsPlatforms }
      )
    }
  )

  const getAnalyticsProps = () => {
    return {
      ...getFeedCategoriesProperties(catalog),
      ...generateProductCountEventProperties(),
    }
  }

  return {
    sendAnalytics,
    getAnalyticsProps,
  }
}

export default useArtCollectionAnalytics
